<div id="upload-component" class="mb-3">
  <div *ngFor="let item of datos">
    <h2 class="copec-rg-20">{{ item.titulo }}</h2>
    <ul>
      <li *ngFor="let cert of item.certificados">
        {{ cert }}
      </li>
    </ul>
  </div>
  <div
    class="upload-container d-flex align-items-center justify-content-center"
  >
    <label for="file-upload" class="custom-file-upload">Cargar documento</label>
    <input
      id="file-upload"
      type="file"
      #fileInput
      (change)="onFileSelected($event)"
      multiple
      [disabled]="files.length === maxFiles"
    />
  </div>
  <p class="copec-rg-16">Tipos de archivos permitidos: .pdf .jpg. y .xlsx Maximo Tamaño de Archivo 5MB</p>
  
  <!-- Mensaje adicional personalizado SOLO si se proporciona -->
  <p *ngIf="additionalMessage && additionalMessage.trim() !== ''" class="copec-bold-14 error-messages">
    {{ additionalMessage }}
  </p>

  <p *ngIf="count_files" class="copec-bold-14 max-files-warning">
    La carga de documentos es obligatoria.
  </p>

  <div *ngIf="errorMessages.length > 0" class="copec-bold-14 error-messages">
    <p *ngFor="let errorMessage of errorMessages" class="error-message">
      {{ errorMessage }}
    </p>
  </div>
  <div class="divfiles">
    <div id="upload-remove-document" class="file-list">
      <div *ngFor="let file of files; let i = index" class="file-item">
        {{ file.name.split('#')[0] }}.{{ file.name.split('.').pop() }}
        <button class="remove-btn" (click)="removeFile(i)">X</button>
      </div>
    </div>
  </div>
</div>
